import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InitiateStockTakeModalMutationVariables = Types.Exact<{
  input: Types.InitiateStockTakeInput;
}>;


export type InitiateStockTakeModalMutation = { readonly __typename?: 'Mutation', readonly initiateStockTake: { readonly __typename?: 'StockTake', readonly id: string } };

export type OutstandingStockTakesQueryVariables = Types.Exact<{
  input: Types.StockTakesInput;
}>;


export type OutstandingStockTakesQuery = { readonly __typename?: 'Query', readonly stockTakes: { readonly __typename?: 'StockTakesPage', readonly items: ReadonlyArray<{ readonly __typename?: 'StockTake', readonly id: string, readonly createdAt: string, readonly finalisedAt?: string | null }> } };


export const InitiateStockTakeModalDocument = gql`
    mutation initiateStockTakeModal($input: InitiateStockTakeInput!) {
  initiateStockTake(input: $input) {
    id
  }
}
    `;
export type InitiateStockTakeModalMutationFn = Apollo.MutationFunction<InitiateStockTakeModalMutation, InitiateStockTakeModalMutationVariables>;

/**
 * __useInitiateStockTakeModalMutation__
 *
 * To run a mutation, you first call `useInitiateStockTakeModalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitiateStockTakeModalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initiateStockTakeModalMutation, { data, loading, error }] = useInitiateStockTakeModalMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useInitiateStockTakeModalMutation(baseOptions?: Apollo.MutationHookOptions<InitiateStockTakeModalMutation, InitiateStockTakeModalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InitiateStockTakeModalMutation, InitiateStockTakeModalMutationVariables>(InitiateStockTakeModalDocument, options);
      }
export type InitiateStockTakeModalMutationHookResult = ReturnType<typeof useInitiateStockTakeModalMutation>;
export type InitiateStockTakeModalMutationResult = Apollo.MutationResult<InitiateStockTakeModalMutation>;
export type InitiateStockTakeModalMutationOptions = Apollo.BaseMutationOptions<InitiateStockTakeModalMutation, InitiateStockTakeModalMutationVariables>;
export const OutstandingStockTakesDocument = gql`
    query outstandingStockTakes($input: StockTakesInput!) {
  stockTakes(input: $input, options: {pageSize: 1}) {
    items {
      id
      createdAt
      finalisedAt
    }
  }
}
    `;

/**
 * __useOutstandingStockTakesQuery__
 *
 * To run a query within a React component, call `useOutstandingStockTakesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOutstandingStockTakesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOutstandingStockTakesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOutstandingStockTakesQuery(baseOptions: Apollo.QueryHookOptions<OutstandingStockTakesQuery, OutstandingStockTakesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OutstandingStockTakesQuery, OutstandingStockTakesQueryVariables>(OutstandingStockTakesDocument, options);
      }
export function useOutstandingStockTakesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OutstandingStockTakesQuery, OutstandingStockTakesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OutstandingStockTakesQuery, OutstandingStockTakesQueryVariables>(OutstandingStockTakesDocument, options);
        }
export type OutstandingStockTakesQueryHookResult = ReturnType<typeof useOutstandingStockTakesQuery>;
export type OutstandingStockTakesLazyQueryHookResult = ReturnType<typeof useOutstandingStockTakesLazyQuery>;
export type OutstandingStockTakesQueryResult = Apollo.QueryResult<OutstandingStockTakesQuery, OutstandingStockTakesQueryVariables>;